import logo from "../../Images/brand/logo.png"

function Header_home(){
    return <>
        <div className="hidden bg-indigo-600 md:inline">
            <div className="container px-3 py-3 mx-auto sm:px-6 lg:px-8">
                <div className="flex flex-wrap items-center justify-between">
                <div className="flex items-center flex-1 w-0">
                    <span className="flex p-2 text-xl bg-indigo-800 rounded-lg">
                    <i className="p-2 text-white ph-brain rounded-3xl animation-smooth"></i>
                    </span>
                    <p className="ml-3 text-xl font-medium text-white">
                    <span className="inline">Do you have any suggestions or feedback?</span>
                    </p>
                </div>
                <div className="flex-shrink-0 order-3 w-full mt-2 sm:order-2 sm:mt-0 sm:w-auto">
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSd-P-wBbmG87NK88sGlOgcPRDboPzFW-D4c0tsnoYIBUmBPmQ/viewform"
                    className="flex items-center justify-center px-4 py-2 text-sm font-medium text-indigo-600 bg-white border border-transparent rounded-md shadow-sm hover:bg-indigo-50">
                    Tell us
                    </a>
                </div>
                </div>
            </div>
        </div>
            {/* Top Bar */}
            <header className="sticky top-0 z-50 bg-white md:px-24 drop-shadow-md">
            <div className="flex justify-center gap-4 p-5">
                <a href="/"><img className="w-40" src={logo} alt="Virtuous LOGO" /></a>
            </div>
            </header>
    </>
}

export default Header_home;